import PickProgress from "../pick-progress";
import {PickStatus} from "../enums/pick-enums";
import ItemLocation from "../item-location";

export default class ReportIssueForItemResponse {
    constructor() {
        this.pickProgress = new PickProgress();
        this.pickStatus = PickStatus.IN_PROGRESS;
        this.itemLocation = new ItemLocation();
    }
}


// WEBPACK FOOTER //
// ./src/models/response/report-issue-for-item-response.js